import React from 'react';
import { Polyline } from '@react-google-maps/api';
import { COLOR_MAP_ARROW } from '../../theme';

type PropsType = {
    pickupLat: number,
    pickupLng: number,
    deliveryLat: number,
    deliveryLng: number
}

export default function MapArrow({
    pickupLat,
    pickupLng,
    deliveryLat,
    deliveryLng
}: PropsType) {
    const polylineOptions = {
        path: [
            { lat: pickupLat, lng: pickupLng },
            { lat: deliveryLat, lng: deliveryLng },
        ],
        strokeOpacity: 0.5,
        strokeWeight: 4,
        strokeColor: COLOR_MAP_ARROW,
        icons: [{
            icon: {
                path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                scale: 4
            },
            offset: '50%'
        }]
    };

    return (
        <Polyline options={polylineOptions} />
    );
}
